import { useAsync } from "@/shared/hooks";
import { useParams } from "react-router-dom";
import { viewPlayerLoader } from "./loaders/player-loader";
import { PlayerPrintPage } from "./components/PlayerPrintPage";

export function PlayerPrint() {
  const { playerId } = useParams();

  const { response, loading } = useAsync(viewPlayerLoader, {
    playerId: Number(playerId),
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  const player = response?.player;
  const scores = response?.scores;
  if (!player) {
    return <div>Player not found</div>;
  }

  return <PlayerPrintPage player={player} scores={scores} />;
}
